package com.parmartechnologies.core.feature.product.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class Product @OptIn(ExperimentalTime::class) constructor(
    @SerialName("product_id") var ProductId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("category_id") var CategoryID: String = "",
    @SerialName("sub_category_id") var SubCategoryID: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("is_blacklisted") var IsBlacklisted: Int = 0,
    @SerialName("name") var Name: String = "",
    @SerialName("quantity") var Quantity: Long = 0,
    @SerialName("description") var Description: String = "",
    @SerialName("manage_inventory") var ManageInventory: Int = 0,
    @SerialName("product_price") var ProductPrice: ProductPrice = ProductPrice(),
): BaseDataClass(){

    @OptIn(ExperimentalTime::class)
    fun toCartItem(inventory: Inventory?): CartItem {
        if(inventory != null && inventory._id.isNotEmpty()){
            val item = CartItem(
                uniqueID = Clock.System.now().epochSeconds,
                product = this,
                inventory = Inventory(),
                price = this.ProductPrice,
            )
            item._id = inventory._id
            return item
        }else{
            val item = CartItem(
                uniqueID = Clock.System.now().epochSeconds,
                product = this,
                inventory = Inventory(),
                price = this.ProductPrice,
            )
            item._id = this._id
            return item
        }
    }
}